import React from 'react';

import { BaseIconProps } from '.';

export const Comments = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(21.588774,0,0,21.588774,-10902.331,-12725.33)"
    d="m 551.726,628.004 c 2.076,-2.258 3.3,-5.012 3.3,-7.99 0,-5.811 -4.646,-10.788 -11.23,-12.863 0.079,0.573 0.114,1.155 0.114,1.745 0,9.198 -9.354,16.676 -20.845,16.676 -0.938,0 -1.85,-0.07 -2.753,-0.165 2.736,4.994 9.163,8.503 16.65,8.503 3.56,0 6.87,-0.8 9.666,-2.172 1.894,1.103 4.525,2.172 7.704,2.172 a 0.696,0.696 0 0 0 0.504,-1.173 c -0.026,-0.026 -1.946,-2.102 -3.11,-4.733 z m -10.595,-19.108 c 0,-7.677 -8.086,-13.896 -18.066,-13.896 -9.98,0 -18.065,6.219 -18.065,13.896 0,2.98 1.225,5.724 3.3,7.99 -1.163,2.624 -3.083,4.708 -3.109,4.734 a 0.69,0.69 0 0 0 -0.13,0.756 0.68,0.68 0 0 0 0.634,0.417 c 3.179,0 5.81,-1.069 7.704,-2.172 2.796,1.364 6.105,2.172 9.666,2.172 9.98,0 18.066,-6.219 18.066,-13.897 z"
    fill={fill}
  />
);
